<p-fieldset [legend]="legend" [toggleable]="toggleable" class="mt-2">
  <ng-content></ng-content>
</p-fieldset>
